import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import App from '../App'
import { IniciarSesion } from '../pages/iniciarSesion/IniciarSesion'
import Restablecer from '../pages/iniciarSesion/Restablecer'
import { PrivateRoutes } from './PrivateRoutes'
import { useSelector } from 'react-redux'
import { selectUsuarioActual } from '../redux/slices/autenticacion/autenticacion.slice'

const AppRoutes = () => {
  const user = useSelector(selectUsuarioActual)

  /**
   * La existencia de `usuario` en Redux es la frontera entre rutas publicas y
   * privadas. Los roles especificos se evaluan despues en `PrivateRoutes`.
   */
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          {user ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/inicio' />} />
            </>
          ) : (
            <>
              <Route path='/iniciar-sesion' element={<IniciarSesion />} />
              <Route path='/restablecer' element={<Restablecer></Restablecer>} />
              <Route path='*' element={<Navigate to='/iniciar-sesion' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
